// src/components/Navbar.js

import React from "react";
import { Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import Logo from "../assets/sjlogo.png";

const Navbar = ({ setDrawerOpen }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: { xs: "row" },
        padding: "30px 20px 10px 20px",
      }}
    >
      {/* Logo Section */}
      <Box
        component={Link}
        to="/"
        sx={{
          display: { xs: "flex", sm: "none" },
          alignItems: "center",
          gap: "10px",
          textDecoration: "none",
          height: "100%",
        }}
      >
        <img src={Logo} alt="Logo" style={{ width: "40%" }} loading="lazy" />
      </Box>

      {/* Mobile Menu Icon */}
      <Box
        sx={{
          display: { xs: "block", md: "none" },
        }}
      >
        <IconButton onClick={() => setDrawerOpen(true)}>
          <MenuIcon sx={{ color: "#800001", fontSize: "30px" }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Navbar;
